/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Table_ValueInputs */

const en_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadata Value`)
};

const fr_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur des métadonnées`)
};

const de_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatenwert`)
};

const it_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore dei metadati`)
};

const ru_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значение метаданных`)
};

const es_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor de metadatos`)
};

const zh_cn2_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元数据值`)
};

const ja_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータ値`)
};

const hi_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा मान`)
};

const pt_pt2_event_group_metadata_table_value = /** @type {(inputs: Event_Group_Metadata_Table_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor dos metadados`)
};

/**
* | output |
* | --- |
* | "Metadata Value" |
*
* @param {Event_Group_Metadata_Table_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_table_value = /** @type {((inputs?: Event_Group_Metadata_Table_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Table_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_table_value(inputs)
	if (locale === "de") return de_event_group_metadata_table_value(inputs)
	if (locale === "it") return it_event_group_metadata_table_value(inputs)
	if (locale === "ru") return ru_event_group_metadata_table_value(inputs)
	if (locale === "es") return es_event_group_metadata_table_value(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_table_value(inputs)
	if (locale === "ja") return ja_event_group_metadata_table_value(inputs)
	if (locale === "hi") return hi_event_group_metadata_table_value(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_table_value(inputs)
	return en_event_group_metadata_table_value(inputs)
});